import { useQuery } from '@tanstack/react-query';
import { coSellMsftApi } from 'packages/tackle-api';

export interface MsftCoSellEnumOption {
  value: string | boolean | number;
  display: string;
}

export interface MsftCoSellEnumMap {
  [key: string]: MsftCoSellEnumOption[];
}

export const getMsftCoSellEnumValues = async () => {
  try {
    const result: { [key: string]: Array<MsftCoSellEnumOption> } =
      await coSellMsftApi
        .get(`api/settings/picklist-options`, {
          timeout: 20000,
        })
        .json();

    return result;
  } catch (error) {
    reportError(error);
    throw error;
  }
};

/** query to fetch the generic Pick list options for AWS Offer
 *
 */
export function useGetMsftCoSellEnumsQuery({ enabled }: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['msft-co-sell-picklist-options'],
    queryFn: () => getMsftCoSellEnumValues(),
    // this should never change, so no need to refetch
    staleTime: Infinity,
    enabled: !!enabled,
  });
}
